const INTERNAL_DOMAIN = '@transactionlink.io'

export const isInternalUser = (email: string): boolean => {
    if (!email) return false
    return email.toLowerCase().endsWith(INTERNAL_DOMAIN)
}